import React from "react";
import vanImage from "../../asset/van.jpg";

export function AboutUs() {
  return (
    <div className="mt-5" id="aboutUs">
      <div className="mx-5">
        <h1 className="fs-1 fw-bold font-monospace text-center mb-5">
          Über uns
        </h1>

        <div className="d-flex justify-content-around align-items-center">
          <p className="fs-3 text-start" style={{ maxWidth: "700px" }}>
            Wir sind Ihr zuverlässiger Partner für Umzugsservices, Transport,
            Entrümpelung und Reinigung. Mit langjähriger Erfahrung sorgen wir
            dafür, dass Ihr Umzug stressfrei, effizient und pünktlich abläuft.
            Unser engagiertes Team steht Ihnen in allen Phasen des Umzugs zur
            Seite – vom sicheren Transport Ihrer Möbel bis hin zur gründlichen
            Endreinigung. Wir legen Wert auf Sorgfalt, Professionalität und
            höchste Kundenzufriedenheit. Lassen Sie uns gemeinsam Ihren Umzug
            einfach und unkompliziert gestalten!
          </p>

          <img
            className="responsive-img"
            style={{ maxWidth: "360px" }}
            src={vanImage}
            alt="Van"
          />
        </div>
      </div>
    </div>
  );
}